import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { HourlyData } from '../../types';

interface HourlyTrafficChartProps {
  data: HourlyData[] | null;
  color: string;
}

export function HourlyTrafficChart({ data, color }: HourlyTrafficChartProps) {
  if (!data || data.length === 0) {
    return null;
  }

  const chartData = data.map((d) => ({
    hour: `${d.hour}h`,
    'Visitantes Únicos': d.visitors,
    'Requisições Humanas': d.humanRequests ?? d.requests,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Visitantes por Hora</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="hour" className="text-xs" />
            <YAxis className="text-xs" />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--background))',
                border: '1px solid hsl(var(--border))',
              }}
            />
            <Legend />
            <Bar dataKey="Visitantes Únicos" fill={color} />
            <Bar dataKey="Requisições Humanas" fill={color + '40'} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
